import { revokedEvent } from "./shared";

export function connectNotifications(
  workspaceId: string,
  onChange: () => void,
  onStatus: (live: boolean) => void,
  onRevoked: () => void,
) {
  let stopped = false,
    cursor = "0",
    attempt = 0,
    socket: WebSocket | null = null;
  let retry: ReturnType<typeof setTimeout> | undefined;
  const advance = (value: unknown) => {
    if (
      typeof value === "string" &&
      /^(0|[1-9][0-9]{0,18})$/.test(value) &&
      BigInt(value) <= 9223372036854775807n &&
      BigInt(value) > BigInt(cursor)
    )
      cursor = value;
  };
  const connect = () => {
    if (stopped) return;
    const url = new URL(
      `/api/v1/workspaces/${workspaceId}/notifications/live`,
      location.origin,
    );
    url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
    url.searchParams.set("after", cursor);
    socket = new WebSocket(url);
    socket.onmessage = (event) => {
      if (stopped) return;
      try {
        const message = JSON.parse(event.data);
        if (message.type === "ready") {
          advance(message.cursor);
          attempt = 0;
          onStatus(true);
          onChange();
        } else if (
          ["change", "changed", "removed", "alert"].includes(message.type)
        ) {
          advance(message.sequence);
          onChange();
        }
      } catch {
        /* An invalid frame never becomes product data. */
      }
    };
    socket.onerror = () => onStatus(false);
    socket.onclose = (event) => {
      if (stopped) return;
      onStatus(false);
      if ([4401, 4403, 4404].includes(event.code)) {
        stopped = true;
        onRevoked();
        window.dispatchEvent(
          new CustomEvent(revokedEvent, { detail: workspaceId }),
        );
        if (event.code === 4401)
          window.dispatchEvent(new Event("sol:session-expired"));
        return;
      }
      retry = setTimeout(connect, Math.min(15000, 1000 * 2 ** attempt++));
    };
  };
  connect();
  return () => {
    stopped = true;
    clearTimeout(retry);
    socket?.close(1000, "Leaving notification stream.");
    onStatus(false);
  };
}
